import { PaginatedBody } from "./generic.type";

export enum FilterTypeEnum {
  SELECT = "SELECT",
  MULTISELECT = "MULTISELECT",
  CHIP = "CHIP",
}

export type FilterOption = {
  value: number | string;
  label: string;
};

export type Filter = {
  key: string;
  label: string;
  type: FilterTypeEnum;
  options: FilterOption[];
};

export type FilterCollaborator = {
  org: Filter[];
  relation: Filter[];
  cmState: Filter[];
  techSkills: Filter[];
};

export type GetFiltersCollaboratorsResponse = FilterCollaborator;

export type FilterConfigCollaborator = {
  org: Filter[];
  cmState: Filter[];
};

export type GetFiltersPotentialMatrixResponse = {
  practice: FilterOption[];
};

export type FilterCourse = {
  org: Filter[];
  features: Filter[];
};

export type GetFiltersCoursesResponse = FilterCourse;

export type FilterCertification = {
  org: Filter[];
  features: Filter[];
};

export type GetFiltersCertificationsResponse = FilterCertification;

export type FilterCareerManager = {
  org: Filter[];
  relation: Filter[];
};

export type GetFiltersCareerManagersResponse = FilterCareerManager;

export type GetFiltersCollaboratorHistoryProjectsResponse = {
  timeline: Filter[];
  details: Filter[];
};

export type FilterConfigCollaborators = {
  org: Filter[];
  relationCmSheet: Filter[];
};

export type GetFiltersConfigCollaboratorsResponse = FilterConfigCollaborators;

export enum PotentialMatrixFilterKeyEnum {
  YEAR = "year",
  PRACTICE = "practice",
  COMPETENCE = "cc",
  TYPE = "type",
  INTERNAL_GRADE = "internalGrade",
  HIDDEN_COLLABORATORS = "hiddenCollaborators",
  COLLABORATOR_ID = "collaboratorId",
}

export type TechSkillsPropertyNameResponse = PaginatedBody<string>;

export type OrganizationPropertyNameResponse = FilterOption[];
